
import logger from '@/utils/logger'
import {HTTP, HTTPImage, updateApiCredentials} from './repository'
export default{
    methods:{
        AddUserToAPI(user){
            //logger.debug('add user to api ' + user.userId + ' ' + user.userKey)
            // Use the centralized credential management system
            updateApiCredentials(user)
        },

        // Method to revert to guest credentials (for logout)
        SetGuestCredentials(){
            updateApiCredentials(null)
        },
        getFailureResponse(message){
            return {
                'Successful':false,
                'Message':message
            }
        },
        async callAPI(req,method){
            try{
                logger.debug(`🔄 API Call: ${method}`, {
                    url: HTTP.defaults.baseURL + '/' + method,
                    request: req,
                    headers: {
                        adminuser: HTTP.defaults.headers.post['adminuser'],
                        token: HTTP.defaults.headers.post['token']
                    }
                });

                var response = await HTTP.post(method,req)

                logger.debug(`✅ API Response: ${method}`, {
                    status: response.status,
                    data: response.data,
                    headers: response.headers
                });

                if(response.data.Successful==false){
                    logger.debug(`❌ API Error: ${method}`, response.data.RequestException);
                    return this.getFailureResponse(response.data.RequestException.Message)
                }
                return response.data
            }
            catch(e){
                logger.debug(`💥 API Exception: ${method}`, e)
                return this.getFailureResponse(e.message)
            }
        },

        async callAPI_Image(req,method){
            try{

                var response = await HTTPImage.post(method,req)
                if(response.data.Successful==false){
                    return this.getFailureResponse(response.data.RequestException.Message)
                }
                return response.data
            }
            catch(e){
                logger.debug('!' + e)
                return this.getFailureResponse(e.message)
            }
        },

        // GET API method for enhanced repository compatibility
        async callAPIGet(endpoint){
            try{
                logger.debug(`🔄 API GET Call: ${endpoint}`, {
                    url: HTTP.defaults.baseURL + '/' + endpoint,
                    headers: {
                        adminuser: HTTP.defaults.headers.post['adminuser'],
                        token: HTTP.defaults.headers.post['token']
                    }
                });

                var response = await HTTP.get(endpoint)

                logger.debug(`✅ API GET Response: ${endpoint}`, {
                    status: response.status,
                    data: response.data,
                    headers: response.headers
                });

                if(response.data.Successful==false){
                    logger.debug(`❌ API GET Error: ${endpoint}`, response.data.RequestException);
                    return this.getFailureResponse(response.data.RequestException.Message)
                }
                return response.data
            }
            catch(e){
                logger.debug(`💥 API GET Exception: ${endpoint}`, e)
                return this.getFailureResponse(e.message)
            }
        },
    },

}